import styled from "styled-components"


const Brand = styled.a`

    font-size: 1.5rem;
    font-weight: bold;
    cursor:pointer;
    text-align: center;
    vertical-align: middle;
    align-self: center;
    justify-content: center;
    color: ${({ theme }) => theme.brandTextColor};
    padding-left: 0.8rem;
    margin: 0, auto;
	&:hover {
		color: ${({ theme }) => theme.brandTextColorHover};
	}

	outline: none;
	text-decoration: none;

	:hover {
		opacity: 0.75;
	}

	/* Tablets */
	@media (max-width: 1400px) {
    	font-size: 1.4rem;
    	padding-left: 0.6rem;
	}

	/* Mobiles */
	@media (max-width: 640px) {
    	font-size: 1rem;
    	padding-left: 0.4rem;
	}

`;

export default Brand;